import { render, staticRenderFns } from "./AbaEditarGestorPorUG.vue?vue&type=template&id=803b97e0&scoped=true"
import script from "./AbaEditarGestorPorUG.vue?vue&type=script&lang=ts"
export * from "./AbaEditarGestorPorUG.vue?vue&type=script&lang=ts"
import style0 from "./AbaEditarGestorPorUG.vue?vue&type=style&index=0&id=803b97e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803b97e0",
  null
  
)

export default component.exports